import React from 'react';

const Loading = () => {
  return <div className="spinner-border text-info" />;
};

export default Loading;
